<template>
  <SelectedUniversity />
</template>

<script>
import SelectedUniversity from '@/components/content/partners/SelectedPartner.vue'

export default {
  name: 'University',
  components: { SelectedUniversity }
}
</script>

<style scoped>

</style>
